export default "__VITE_ASSET__3Frf11A8__"